"use client";

import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import type { ILeaderboardColumns } from "@/sanity/pages/PageLeaderboardTemplate";

import Leaderboard from "./Leaderboard";
import { SAMPLE_LEADERBOARD } from "./sample";
import type { LeaderboardEntry } from "./types";

type LeaderboardView = "monthly" | "hall-of-fame";

export default function LeaderboardLive(props: {
  chip?: string;
  title?: string;
  subtitle?: string;
  boardTitle?: string;
  tabMonthly?: string;
  tabHallOfFame?: string;
  columns?: ILeaderboardColumns;
}) {
  const [view, setView] = useState<LeaderboardView>("monthly");

  const { data } = useQuery<LeaderboardEntry[]>({
    queryKey: ["leaderboard", view],
    queryFn: () => fetch(`/api/leaderboard?view=${view}`).then((res) => res.json()),
  });

  const entries = Array.isArray(data) && data.length > 0 ? data : SAMPLE_LEADERBOARD;

  return (
    <Leaderboard {...props} entries={entries} view={view} onViewChange={setView} />
  );
}
